

















import { computed, defineComponent, onBeforeUnmount, ref } from "@vue/composition-api";
import { ContentFeedType } from "@scrile/api-provider/dist/api/ContentFeedProvider";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import useUserTags from "@/hooks/useUserTags";
import emitter from "@/lib/emitter";
import config from "@/config";
import { EVENTS } from "@/const";
import SelectUserTagsModal from "@/components/SelectUserTagsModal";
import CreatePostController from "./components/CreatePostController";

export default defineComponent({
  name: "CreatePost",
  components: { CreatePostController, SelectUserTagsModal },
  setup() {
    const { authUser } = useAuthUser();
    const { userTagsGetData } = useUserTags();

    const userId = ref("");
    const loading = ref(false);
    const userTags = ref<string[]>([]);
    const showCreate = ref(false);
    const postId = ref("");
    const type = ref<ContentFeedType>("");

    const checkedRole = computed(() => checkRole(authUser.value?.role || "", "creator"));

    const showSelectTags = computed({
      get() {
        return checkedRole.value && userTags.value.length === 0 && showCreate.value && config.featureTags && false;
      },
      set(value: boolean) {
        showCreate.value = value;
      },
    });

    const allowShowCreate = computed(() => showCreate.value && !showSelectTags.value);
    const onClose = () => {
      postId.value = "";
      userId.value = "";
      showCreate.value = false;
    };

    const getData = async () => {
      try {
        loading.value = true;
        userTags.value = config.featureTags ? await userTagsGetData() : [];
      } finally {
        loading.value = false;
      }
    };

    const showCreatePost = async (data: { postId?: string; userId: string; type?: ContentFeedType }) => {
      try {
        await getData();
      } finally {
        postId.value = data.postId || "";
        type.value = data.type || "";
        userId.value = data.userId;
        showCreate.value = true;
      }
    };
    emitter.on<any>(EVENTS.SHOW_CREATE_POST, showCreatePost);

    onBeforeUnmount(() => {
      emitter.off<any>(EVENTS.SHOW_CREATE_POST, showCreatePost);
    });

    return {
      userId,
      userTags,
      showCreate,
      postId,
      type,
      allowShowCreate,
      showSelectTags,
      onClose,
    };
  },
});
